import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpTextLinkComponent from './adpTextLink.component';

let adpTextLinkModule = angular.module('adpTextLink', [
  uiRouter
])

.component('adpTextLink', adpTextLinkComponent)

.name;

export default adpTextLinkModule;



// WEBPACK FOOTER //
// ./src/app/components/adpTextLink/adpTextLink.js